export default {
  setSelectedYear (state: {[key:string]: string}, value: string) {
    state.selectedYear = value
  },
  setSelectedSeason (state: {[key:string]: string}, value: string) {
    state.selectedSeason = value
  }
}
